/**
 * Permission names the web app checks. The API is the authority (apps/api/src/common/
 * permissions.ts, sent in auth/me); this list only names them so routes and menus can
 * be guarded. Names match E1's PERMISSIONS — a name the API never grants just hides
 * the menu entry, it never opens anything.
 */
export const P = {
  dashboard: 'dashboard.view',
  alerts: 'alerts.view',
  itemsView: 'items.view',
  itemsCreate: 'items.create',
  itemsEdit: 'items.edit',
  itemsImport: 'items.import',
  tagsBind: 'tags.bind',
  categories: 'categories.manage',
  labels: 'labels.print',
  transfersView: 'transfers.view',
  salesView: 'sales.view',
  salesRecord: 'sales.record',
  cashup: 'cashup.submit',
  cashupSignoff: 'cashup.signoff',
  customers: 'customers.view',
  pawnView: 'pawn.view',
  pawnCreate: 'pawn.create',
  pawnForfeit: 'pawn.forfeit',
  pawnSchemes: 'pawn.schemes.manage',
  cashbook: 'cashbook.view',
  auditsView: 'audits.view',
  auditsCount: 'audits.count',
  reports: 'reports.view',
  branchesView: 'branches.view',
  branches: 'branches.manage',
  users: 'users.manage',
  roles: 'roles.manage',
  settings: 'settings.manage',
  ratesView: 'rates.view',
  rates: 'rates.manage',
  activity: 'activity.view',
  approvalsManager: 'approvals.manager',
  approvalsOwner: 'approvals.owner',
  fxView: 'fx.view',
  fxTransact: 'fx.transact',
  fxRates: 'fx.rates',
  fxAdjust: 'fx.adjust',
} as const;

export type PermissionName = (typeof P)[keyof typeof P];
